interface ValidationItem {
  loc?: (string | number)[];
  msg?: string;
}

interface BookingErrorResult {
  error: string;
  fieldErrors: Record<string, string>;
}

const FIELD_MAP: Record<string, string> = {
  customer_e_mail: 'customerEmail',
  customer_name: 'customerName',
};

// Translate axios error from POST /workers/:id/book into a top-level error
// message and per-field error map. Mirrors the field names the form uses.
export default function parseBookingError(err: unknown): BookingErrorResult {
  const detail = (err as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  if (!detail) {
    return { error: 'Failed to book appointment. Please try again.', fieldErrors: {} };
  }
  if (typeof detail === 'string') {
    return { error: detail, fieldErrors: {} };
  }
  if (Array.isArray(detail)) {
    const fieldErrors: Record<string, string> = {};
    const messages: string[] = [];
    (detail as ValidationItem[]).forEach((item) => {
      const field = item.loc?.[item.loc.length - 1] as string | undefined;
      const mapped = field ? FIELD_MAP[field] : undefined;
      if (mapped) {
        fieldErrors[mapped] = item.msg ?? '';
      } else if (item.msg) {
        messages.push(field ? `${field}: ${item.msg}` : item.msg);
      }
    });
    return { error: messages.join(', '), fieldErrors };
  }
  return { error: 'Failed to book appointment. Please try again.', fieldErrors: {} };
}
